import { PortColor } from "../../../utils/appConstants";
import PortImage from "../../ResourceImages/Port";

export const StatusButton: React.FC<{ port: any; size: number }> = ({ size, port }) => {
  const crossConnectPortId = port.crossConnectPortId || port.cross_connect_port_id;
  const crossConnectVerified = port.crossConnectVerified || port.cross_connect_verified;
  if (port.status === "bought_port" && !port.purchasePortId) {
    return <PortImage size={size} color={PortColor.Red} plugColor={PortColor.Red} />;
  } else if (port.status === "port_put_up_for_sale") {
    return <PortImage size={size} color={PortColor.Yellow} plugColor={PortColor.LightYellow} />;
  } else if (crossConnectPortId && crossConnectVerified && port.initialStatus) {
    // green cc
    return <PortImage size={size} color={PortColor.Green} plugColor={PortColor.Green} />;
  } else if (crossConnectPortId && !port.initialStatus) {
    // both ports must be grey
    return <PortImage size={size} color={PortColor.Grey} plugColor={PortColor.Grey} />;
  } else if (port.verified || port.purchasePortId) {
    return <PortImage size={size} color={PortColor.Green} plugColor={PortColor.LightGreen} />;
  } else {
    return <PortImage size={size} color={PortColor.Grey} plugColor={PortColor.LightGrey} />;
  }
};
